// extracted by mini-css-extract-plugin
module.exports = {"Block":"HaveAcc_Block__2K_kj","HaveAcc":"HaveAcc_HaveAcc__NnMbi","HaveAcc__Arrow":"HaveAcc_HaveAcc__Arrow__3pyzf","HaveAcc__Link":"HaveAcc_HaveAcc__Link__Z7kMa"};